import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('Uncaught error:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          role="alert"
          style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#f9fafb',
            padding: '1rem',
            fontFamily: 'system-ui, -apple-system, sans-serif',
          }}
        >
          <div
            style={{
              maxWidth: '32rem',
              width: '100%',
              backgroundColor: 'white',
              border: '1px solid #e5e7eb',
              borderRadius: '0.5rem',
              padding: '2rem',
              textAlign: 'center',
              boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
            }}
          >
            <h1 style={{ color: '#003366', fontSize: '1.5rem', margin: '0 0 0.5rem' }}>
              Something went wrong
            </h1>
            <p style={{ color: '#6b7280', margin: '0 0 1.5rem' }}>
              An unexpected error occurred while rendering the application. Please reload the page to try again. If the problem persists, contact{' '}
              <a
                href="https://www.becquerelinstitute.eu/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#003366' }}
              >
                Becquerel Institute
              </a>
              .
            </p>
            <button
              onClick={() => window.location.reload()}
              style={{
                backgroundColor: '#003366',
                color: 'white',
                border: 'none',
                borderRadius: '0.25rem',
                padding: '0.5rem 1.5rem',
                cursor: 'pointer',
                fontSize: '0.875rem',
              }}
            >
              Reload page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
